module.exports = __webpack_public_path__ + "static/media/alien.7d0160d3.jfif";